<template>
  <el-card shadow="never" class="card">
    <h3>{{ data.title }}</h3>

    <p class="summary">{{ data.summary }}</p>

    <pre v-if="data.example">{{ data.example }}</pre>

    <el-alert
      title="⚠️ 本条由 AI 生成，已人工校验"
      type="warning"
      :closable="false"
      show-icon
    />
  </el-card>
</template>

<script>
export default {
  name: "KnowledgeCardMini",
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.card {
  max-width: 680px;
  margin: 2rem auto;
  text-align: left;
}
pre {
  background: #f5f7fa;
  padding: 8px;
  font-family: monospace;
  border-radius: 4px;
  overflow-x: auto;
}
.summary {
  color: #606266;
  line-height: 1.6;
}
</style>
